var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend pa-2"},[_c('span',{staticClass:"font-weight-light"},[_vm._v("LEGEND")]),_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }